import { LngLatBounds } from 'mapbox-gl';
import { saveAs } from 'file-saver';

import { ResultsMapGeoJson } from '../types/results-map';

import {
  DetailedResultItem,
  ResultsResponse,
  ResultsSummary,
  ResultsValuesResponse,
} from '../types/results';

import {
  Filters,
  FORM_STATUS,
  MultisectActionDto,
  formatFilters,
  handleRequest,
  privateClient,
} from '@data-access';

export const resultsApi = {
  list: async (filters: Filters) => {
    const res = await privateClient
      .get('results/', {
        searchParams: {
          ...formatFilters(filters),
        },
      })
      .json<ResultsResponse>();

    return res;
  },

  getSummary: async (filters: Filters) => {
    const res = await privateClient
      .get('results/summary/', {
        searchParams: {
          ...formatFilters(filters),
        },
      })
      .json<ResultsSummary>();

    return res;
  },

  values: async () => {
    const res = await privateClient
      .get('results/values/')
      .json<ResultsValuesResponse>();
    return res;
  },

  getById: async (id: number) => {
    const res = await privateClient
      .get(`results/${id}/`)
      .json<DetailedResultItem>();

    return res;
  },

  exportSynthesis: async (data: MultisectActionDto) => {
    const res = await handleRequest<{
      id: number;
      status: FORM_STATUS;
      instance_id: number;
    }>(
      privateClient
        .post(`results/prep_synthesis/`, {
          json: data,
        })
        .json(),
    );

    return res;
  },

  downloadExport: async (opts: { id: number }) => {
    const res = await handleRequest(
      privateClient.post(`results/synthesis/`, {
        json: {
          instance_id: opts.id,
        },
      }),
    );

    const filename = res.headers
      .get('content-disposition')
      ?.split(';')
      .find((n) => n.includes('filename='))
      ?.replace('filename=', '')
      .trim();

    const blob = await res.blob();
    saveAs(blob, filename);

    return res;
  },

  getMapInBounds: async (
    bounds: LngLatBounds,
    cluster: boolean,
    zoom: number,
    filters?: Filters,
  ) => {
    const formattedBounds = bounds.toArray().flat();
    return privateClient
      .get('results/map/', {
        searchParams: {
          bbox: formattedBounds.join(','),
          cluster,
          zoom,
          ...(filters ? formatFilters(filters) : {}),
        },
      })
      .json<ResultsMapGeoJson>();
  },
};
